export default {
	COPY_TO_CLIPBOARD: 'Copy to clipboard',
	COPIED_TO_CLIPBOARD: 'Copied to clipboard!',
	COPIED_TO_CLIPBOARD_ERROR: "That didn't work, grab it here",
};
